import { GTM_ID } from '../analytics.js';
/**
 * Notice — the "cookie" bar, except this set doesn't use cookies.
 * An honest one-liner: what's stored (a sound preference), what isn't
 * (everything else), where Chotbat messages go, and that the camera
 * channel never leaves the device. Dismissal is remembered locally.
 */
const KEY = 'sb:notice';

export class Notice {
  constructor({ delay = 2200 } = {}) {
    let seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch { /* private mode */ }
    if (seen) return;
    this.el = document.createElement('aside');
    this.el.className = 'notice';
    this.el.setAttribute('role', 'note');
    this.el.setAttribute('aria-label', 'Privacy notice');
    this.el.innerHTML = `
      <p class="notice__text">${GTM_ID
        ? `<b>// one cookie.</b> Google Analytics counts visits. Beyond that this set only remembers your sound setting, on your own device.`
        : `<b>// no cookies.</b> This set remembers your sound setting on your own device and nothing else — no analytics, no tracking.`}
        The camera channel never leaves your browser. Chotbat sends what you type to Google Gemini to get an answer.
        <a href="/llms.txt">Details</a></p>
      <button type="button" class="notice__ok">Got it</button>`;
    document.body.appendChild(this.el);
    this.el.querySelector('.notice__ok').addEventListener('click', () => this.dismiss());
    setTimeout(() => this.el.classList.add('is-on'), delay);
  }

  dismiss() {
    try { localStorage.setItem(KEY, '1'); } catch { /* ignore */ }
    this.el.classList.remove('is-on');
    setTimeout(() => this.el.remove(), 400);
  }
}
